namespace Matrix {
    export enum WorkflowCommentOption {
        None = 0,
        Mandatory = 1,
        Optional = 2
    }
    Serenity.Decorators.registerEnumType(WorkflowCommentOption, 'Matrix.WorkflowCommentOption');
}
